enum ActionTypes  {
    ERROR_NOTIFY= 'ERROR_NOTIFY',
    DEL_SAVED_PROJECT= "DEL_SAVED_PROJECT",
    RESTORE_DELETED_PROJECT= "RESTORE_DELETED_PROJECT",
    DEL_PURCHASED_PROJECT= "DEL_PURCHASED_PROJECT",
    DELETED_ARCHIVED = "DeletedArchived",
    CURRENT_TAB_NAME= "CURRENT_TAB_NAME",
    RESET_STORE_DATA= "RESET_STORE_DATA",
    REMOVE_PROJECT_FROM_CART= "REMOVE_PROJECT_FROM_CART",
    GET_COUNT= "GET_COUNT",
    ARCHIVED= "Archived",
    SAVED="saved",
    PURCHASED= "purchased",
    DELETED="deleted",
    SOFT_DELETED= "SoftDeleted",
    MODIFIED= "Modified",
    FREE= "Free",
    DELETED_FREE= "DeletedFree",
    EMPTY=""
}

export default ActionTypes